<app-header-front-end></app-header-front-end>
<app-shared-suggestion-shows></app-shared-suggestion-shows>
<app-basic-menu></app-basic-menu>
